<!--
Author: TangChen
Date: 2018-09-19
Desc: 协议内容
-->
<template>
    <div class="comp-agreement2 comp">
        <el-dialog
            :visible.sync="value"
            :title="title"
            :close-on-click-modal="false"
            class="prop info-tips"
            width="820px"
            top="5vh"
            custom-class="pdf-dialog"
        >
            <span class="dialog-close" @click="confirmCon">
                <i class="el-icon-close"></i>
            </span>
            <div class="investor-tips">
                <p v-html="content"></p>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-on:click="confirmCon">
                    我已知晓
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import agreement from "@/config/agreements";
export default {
    name: "Agreement",
    props: {
        agrCon: {
            type: String,
            required: true
        },
        value: {
            type: Boolean,
            default: false
        },
        title:{
            type:String,
            default:""
        }
    },
    data () {
        return {
            content: ""
        };
    },
    watch: {
        value(val) {
            if (val) {
                this.agreementCon();
            }
        }
    },
    mounted () {
    },
    methods: {
        agreementCon () {
            if (!this.$util.isEmpty(this.agrCon)) {
                this.content = agreement[this.agrCon];
                setTimeout(()=>{
                    document.querySelector(".el-dialog__body").scroll(0,0);
                },0)
            }
        },
        confirmCon() {
            this.$emit("all-read", false);
        },
    }
};
</script>
<style lang="scss">
.comp-agreement2 {
    .close-btn {
        position: absolute;
        top: 5px;
        right: 5px;
        cursor: pointer;
        color: red;
        font-size: 20px;
    }

    .el-dialog__headerbtn i {
        display: none;
    }

    .el-dialog__body {
        max-height: 700px;
        min-height: 300px;
        overflow-y: auto;

    }

    .dialog-close {
        cursor: pointer;
        font-size: 18px;
        color: #999;
        transition: color 0.3s;
        position: absolute;
        right: 20px;
        top: 12px
    }

    .dialog-close:hover {
        color: #333;
    }
}

</style>
